module.exports = __webpack_public_path__ + "static/media/box.ba66418a.svg";